import UserAvatar from '@/frontend/components/qecomps/UserAvatar'
import { useState } from 'react'
import Router from 'next/router'
import Badge from '@/frontend/components/qecomps/Badge'
import Bold from '@/frontend/components/qecomps/Bold'
import TextAreaEditFloat from '@/frontend/components/qecomps/TextAreaEditFloat'
import Text from '@/frontend/components/qecomps/Text'
import ExploreSelectFloat from './ExploreSelectFloat'
import LinkHashtags from '@/frontend/components/qecomps/LinkHashtags'
const CommentsButton = dynamic(() => import('./CommentsButton.tsx').then(x => x.default), { ssr: false })


import Component, { PageEl } from '@/frontend/components/qecomps/Component';
import dynamic from 'next/dynamic'
import TextEndAbbreviation from '@/frontend/components/qecomps/TextEndAbbreviation'
import Link from 'next/link'
import Img from '../qecomps/Img.tsx'
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {
    let [form, setForm] = useState(null)

    const send = async (obj, api) => {
        return await API["journal/" + api](obj)
    }

    let statusimg = global.cdn("/files/close.svg")
    if (props.item.status == "published") {
        statusimg = global.cdn("/files/ok.svg")
    }
    else if (props.item.status == "waiting") {
        statusimg = global.cdn("/files/waiting.svg")
    }



    let Formers = () => {
        return <div style={{ direction: z.lang.dir as any }}>
            {form?.action == "expassign" ? <ExploreSelectFloat query={{ journal: true }} noexplore
                on={async (obj) => {
                    global.setScroller("wind");
                    let adddetailsfromexp = await confirmer("آیا جزئیات از اکسپلور به این پست اضافه شوند؟")
                    let json = await send({
                        jid: props.item.jid,
                        property: "expid",
                        value: obj?.expid || null,
                        adddetailsfromexp
                    },
                        "propeditor")
                    if (json.code == 0) {
                        setForm(null)
                        global.reload()
                    }
                    else {
                        alerter(z.lang.somethingwrong)
                    }
                }} onclose={() => setForm(null)} /> : null}

            {/* {form?.action == "useredit" ? <SimpleEditor item={props.item}
                index={props.index} onclose={() => setForm(null)} /> : null} */}
            {form?.action == "editags" ? <TextAreaEditFloat title={z.lang.editags}
                title2={<Bold>{z.lang.tags + ":"}</Bold>} maxlen={300}
                defaultValue={props.item.tags}
                onclose={() => setForm(null)}
                on={async (txt) => {
                    let json = await send({ jid: props.item.jid, property: "tags", lang: z.lang.code, value: txt }, "propeditor")
                    if (json.code == 0) {
                        props.item.tags = txt
                        setForm(null)
                    }
                    else {
                        alerter(z.lang.somethingwrong)
                    }
                }}
            /> : null}
        </div>
    }


    return <>
        <Formers />
        <div style={{
            flex: 0.9,
            padding: "5px 8px 0 8px",
            direction: z.lang.dir as any
        }}>
            <c-x style={{ minHeight: 100, }}>
                <p className={z.styles.text} id={"hp_" + props.index}>

                    <f-cc style={{ width: 45, height: 35, float: z.lang.dir == "rtl" ? "right" : "left", paddingTop: 15 }}>
                        <UserAvatar width={38} image={props.item.avatar} imageprop={props.item.imageprop}
                            on={() => { props.onavatarclick?.(props.item.uid) }} style={{ cursor: "pointer" }} />
                    </f-cc>

                    <span style={{
                        verticalAlign: "middle", float: z.lang.dir == "rtl" ? "right" : "left",
                        padding: "0 2px"
                    }}>
                        {
                            <Bold on={() => { props.onnameclick?.(props.item.uid) }} style={{
                                cursor: "pointer",
                            }}>
                                {(z.lang.code == "fa" || z.lang.code == "ar") && /^[a-zA-Z0-9._\s]+$/.test(props.item.name) ? <span
                                    style={{ display: "inline-block", transform: 'translateY(1px)', fontSize: 12 }}>
                                    {TextEndAbbreviation(props.item.name, 14)}
                                </span> : TextEndAbbreviation(props.item.name, 14)}
                            </Bold>
                        }

                        {props.item.verify ? <><sp-4 /><sp-4 /></> : null}
                        <Badge verify={props.item.verify} style={{ marginTop: -1.5, height: 14 }} />
                    </span>

                    {props.item.chatenabled ? <f-cc style={{
                        display: "inline-block", verticalAlign: "middle",
                        margin: "0 4px", height: null
                        , float: z.lang.dir == "rtl" ? "right" : "left"
                    }}
                        onClick={() => {
                            Router.push(z.root + "/newchat?jid=" + props.item.jid)
                        }}><a-x className={z.styles.bg2 + " " + z.styles.text} style={{
                            padding: "1.5px 8px",
                            borderRadius: 3,
                        }}>{z.lang.sendmsg}</a-x></f-cc> : null}
                    &nbsp;

                    {LinkHashtags(TextEndAbbreviation(props.item.comment, z.lang.journalmaxlen))}




                    {true || props.item.comment?.length > z.lang.journalmaxlen ?
                        <a-s onClick={() => { props.oncomments?.() }}>{z.lang.more}</a-s> : null}
                    {/* {props.item.isowner || props.item.isadmin ? <f-11
                        style={{ backgroundColor: "#B3D3B4", borderRadius: 3, margin: "0 3px", padding: "0 3px" }}
                        class={z.styles.hover} onClick={() => {
                            setForm({ action: "useredit", index: props.index })
                        }}>{z.lang.edit}</f-11> : null} */}
                    &nbsp;
                    &nbsp;
                    {props.item.isowner || props.item.isadmin ? <>
                        {props.item.private ? <Img className={z.styles.hover} src={global.cdn("/files/lock2.svg")} style={{
                            display: "inline-block",
                            verticalAlign: "middle", width: 17, height: 17
                        }} on={async () => {
                            let json = await send({ jid: props.item.jid, property: "private", value: !props.item.private }, "propeditor")
                            props.item.private = !props.item.private;
                            setForm({ ...form })
                            if (json.code != 0) {
                                props.item.private = !props.item.private;
                                setForm({ ...form })
                                alerter(z.lang.somethingwrong)
                            }
                        }} /> : <Img className={z.styles.hoverfade} src={global.cdn("/files/unlock2.svg")} style={{
                            display: "inline-block",
                            filter: 'grayscale(100%)',
                            verticalAlign: "middle", width: 17, height: 17
                        }} on={async () => {
                            let json = await send({ jid: props.item.jid, property: "private", value: !props.item.private }, "propeditor")
                            props.item.private = !props.item.private;
                            setForm({ ...form })
                            if (json.code != 0) {
                                props.item.private = !props.item.private;
                                setForm({ ...form })
                                alerter(z.lang.somethingwrong)
                            }
                        }} />
                        }</> : null}

                </p>
            </c-x>



            <br-x />
            <p style={{ minHeight: 80, }}>
                {(props.item.tags || "").trim().split(" ").map((t, i) => {
                    let tag = t.replace(/#/g, "").replace(/_/g, " ").trim();

                    return <Link style={{ padding: "0" }}
                        key={"tg_" + tag}
                        // rel="nofollow noopener noreferrer"
                        href={z.root + "/t/" + t.replace(/#/g, "").replace(/#/, "").replace(/_+/g, "-").replace(/\s+/g, "-")}>
                        {z.user.follows.includes(tag.replace(/ /g, "_")) ?
                            <n-tag onClick={(e) => { e.stopPropagation(); }}>{t}</n-tag>
                            : <f-10><sp-3 />{t}<sp-3 /></f-10>}
                    </Link>
                })}

            </p>


            <br-xx />
            <br-x />

            <Text nospace title={z.lang.relserv} body={props.item?.expitem?.title1 || z.lang.qeplayer}
                image={global.cdn(props.item?.expitem?.icon || "/files/logocircular.webp")}
                islink={!!props.item?.expitem}
                href={props.item?.expitem ? (z.root + "/e/" + props.item?.expitem?.app) : null}
                on={() => { global.hasback = true; }}
                onwlink={() => {
                    (props.item.isowner || props.item.isadmin) ? setForm({ ...form, action: "expassign" }) : null
                }}
                wlink={(props.item.isowner || props.item.isadmin) ? z.lang.expassign : null} whighlight
            />
            <br-x />
            <br-xx />
            <f-x style={{ marginBottom: -2 }}>{props.children}</f-x>
            <br-x />
            <br-xx />

            {(props.item.comments || []).map(cmnt => <article className={z.styles.none}>
                <header>
                    <strong>{cmnt.name}</strong>
                </header>
                <p >{cmnt.comment}</p>
            </article>)}
            {props.iswide ? <CommentsButton
                restate={r => {
                    props.item.cmntrestate = r;
                }}
                iswide={true} item={props.item}
                on={() => { props.oncomments?.() }} /> : null}
        </div>


    </>
}